import { render } from "./AppMain.vue?vue&type=template&id=328198e2&scoped=true&ts=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=328198e2&lang=scss&scoped=true"
import "./AppMain.vue?vue&type=style&index=1&id=328198e2&lang=scss"

import exportComponent from "/Users/yuhuiliu/code/btkcode/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328198e2"]])

export default __exports__